<template>
  <BatteryReplacementModal
    v-if="batteryReplacementInsuranceOffer"
    :device-name="cartItem.model"
    :insurance-offer="batteryReplacementInsuranceOffer"
    @decline="emit('decline')"
    @select-offer="
      emit(
        'select-insurance-offer',
        cartItem.listingId,
        batteryReplacementInsuranceOffer,
      )
    "
  />

  <CheapestInsuranceOfferModal
    v-if="!batteryReplacementInsuranceOffer && cheapestInsuranceOffer"
    :device-name="cartItem.model"
    :insurance-offer="cheapestInsuranceOffer"
    @decline="emit('decline')"
    @select-offer="
      emit('select-insurance-offer', cartItem.listingId, cheapestInsuranceOffer)
    "
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type {
  CartItem,
  CheckoutInsuranceOffer,
} from '@backmarket/http-api/src/api-specs-checkout/cart/cart.types'

import BatteryReplacementModal from './components/BatteryReplacementModal/BatteryReplacementModal.vue'
import CheapestInsuranceOfferModal from './components/CheapestInsuranceOfferModal/CheapestInsuranceOfferModal.vue'

const props = defineProps<{
  cartItem: CartItem
}>()

const emit = defineEmits<{
  (
    e: 'select-insurance-offer',
    listingId: string,
    insuranceOffer: CheckoutInsuranceOffer | null,
  ): void
  (e: 'decline'): void
}>()

const cheapestInsuranceOffer = computed(() => {
  return props.cartItem.insuranceOffers
    .filter((insuranceOffer) => !insuranceOffer.defaultOffer)
    .reduce<CheckoutInsuranceOffer | null>((cheapestOffer, insuranceOffer) => {
      if (!cheapestOffer) return insuranceOffer

      if (
        parseFloat(insuranceOffer.price.amount) <
        parseFloat(cheapestOffer.price.amount)
      )
        return insuranceOffer

      return cheapestOffer
    }, null)
})

const batteryReplacementInsuranceOffer = computed(() => {
  return props.cartItem.insuranceOffers.find((offer) =>
    offer.coverageKinds.includes('BATTERY_REPLACEMENT'),
  )
})
</script>
